import React from 'react'

import logoApple from '../../assets/images/apple.png'
import logoAndroid from '../../assets/images/android.png'

import { Row, Col } from 'reactstrap'

import { Link } from 'react-router-dom'

const Rodape = () => {
  return (
    <>
      <Row>
        <Col className="col-6 t-right">
          <div className="">
            <Link to="/">
              <img
                src={logoApple}
                height={45}
                alt=""
                className="auth-logo w-auto"
              />
            </Link>
          </div>
        </Col>
        <Col className="col-6 t-left">
          <Link to="/">
            <img
              src={logoAndroid}
              height={45}
              alt=""
              className="auth-logo w-auto"
            />
          </Link>
        </Col>
      </Row>
      <div className="d-grid mt-2 text-light-blue-01 d-flex align-items-center justify-content-center legal-links-container">
        {' '}
        {}
        <Link to="/BI_EX0003" className="mr-2 legal-link-item">
          {' '}
          Termos de Uso
        </Link>
        <span className="legal-link-separator">|</span>{' '}
        <Link to="/BI_EX0004" className="ml-2 legal-link-item">
          {' '}
          Política de Privacidade
        </Link>
      </div>
      <div className="app-store-buttons"></div>
      <div className="mt-5 mt-md-3 text-center">
        <p className="font-size-12">
          © {new Date().getFullYear()} Copyright Grupo e-Makers - Todos os
          direitos reservados
        </p>
      </div>
    </>
  )
}

export default Rodape
